import { memo, useCallback } from "react";
import { noInput } from "src/utilities/input";

import SingleSelectQuestionLayout, { SingleSelectQuestionLayoutProps } from "./Layout";

export interface SingleSelectQuestionProps
  extends Omit<SingleSelectQuestionLayoutProps, "onChange" | "onNext"> {
  onChange: (value: string | undefined) => void;
  onNext: (value: string) => void;
}

const SingleSelectQuestion = ({ onChange, onNext, value, ...props }: SingleSelectQuestionProps) => {
  const handleNext = useCallback(
    (val?: string) => {
      if (!noInput(val)) {
        onNext?.(val);
      }
    },
    [onNext]
  );

  const handleChange = useCallback(
    (val?: string) => {
      onChange?.(val);
    },
    [onChange]
  );

  return <SingleSelectQuestionLayout {...props} value={value} onChange={handleChange} onNext={handleNext} />;
};

export default memo(SingleSelectQuestion);
